<script setup lang="ts">
/**
 * Оверлей «нет доступа» для левой панели entity-формы и правой панели чата.
 */
import chatLock from '@images/icons/chat_lock.svg?url'
import formLock from '@images/icons/form_lock.svg?url'

const props = withDefaults(defineProps<{
  variant?: 'form' | 'chat'
  title?: string
  subtitle?: string
  image?: string
}>(), {
  variant: 'form',
})

const imageSrc = computed(() => {
  if (props.image) return props.image
  return props.variant === 'chat' ? chatLock : formLock
})

const message = computed(() => {
  if (props.title) return props.title
  return props.variant === 'chat' ? 'У вас нет доступа к чату' : 'Нет доступа'
})
</script>

<template>
  <div
    class="entity-access-denied-overlay d-flex flex-column align-center justify-center ga-3 pa-6 text-center"
    role="status"
  >
    <img
      :src="imageSrc"
      :alt="message"
      class="entity-access-denied-overlay__img"
    >
    <div class="d-flex flex-column align-center ga-1">
      <span class="text-h5 font-weight-medium text-high-emphasis">
        {{ message }}
      </span>
      <span v-if="subtitle" class="text-body-2 text-medium-emphasis" style="max-width: 360px; line-height: 1.4;">
        {{ subtitle }}
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.entity-access-denied-overlay {
  position: absolute;
  z-index: 5;
  inset: 0;
  background-color: rgb(var(--v-theme-access-denied-overlay));
}

.entity-access-denied-overlay__img {
  block-size: auto;
  max-block-size: min(280px, 45%);
  max-inline-size: min(320px, 80%);
  object-fit: contain;
}
</style>
